import React, { useEffect, useRef } from 'react';
import { Modal, Form, Input, Button } from 'antd';

interface EditAddFilesProps {
  visible: boolean;
  onCancel: () => void;
  onSave: (item: any) => void;
  onCancelForm: () => void; // New prop to handle form reset
  initialValues?: any;
  popupTitle: string;
  loading: boolean;
}

const EditAddFiles: React.FC<EditAddFilesProps> = ({
  visible,
  onCancel,
  onSave,
  initialValues,
  popupTitle,
  loading,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef<HTMLFormElement | any>(null);

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [initialValues, visible]);

  const handleSave = () => {
    form
      .validateFields()
      .then((values: any) => {
        initialValues ? onSave({ ...values, id: initialValues.id }) : onSave(values);
        form.resetFields();
      })
      .catch((error: any) => {
        return false;
      });
  };

  const validateWhiteSpace = (_: any, value: string) => {
    if (value && value.trim() === '') {
      return Promise.reject('Input cannot consist only of spaces');
    }
    return Promise.resolve();
  };

  const validateUrl = (rule: any, value: string) => {
    return new Promise<void>((resolve, reject) => {
      const urlRegex = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(:\d{2,5})?(\/[\w.-]*)*\/?$/i;
      if (!value || urlRegex.test(value)) {
        resolve();
      } else {
        reject('Please enter a valid URL');
      }
    });
  };

  return (
    <Modal
      open={visible}
      title={initialValues ? `Edit ${popupTitle}` : `Add ${popupTitle}`}
      onCancel={onCancel}
      onOk={handleSave}
      destroyOnClose
      footer={[
        <Button key='back' onClick={onCancel}>
          Cancel
        </Button>,
        <Button key='submit' type='primary' loading={loading} onClick={handleSave}>
          {initialValues ? 'Update' : 'Submit'}
        </Button>,
      ]}
    >
      <Form
        form={form}
        ref={formRef}
        name='filesForm'
        layout='vertical'
        // initialValues={initialValues}
      >
        <Form.Item
          name='title'
          label='Title'
          rules={[
            { required: true, message: 'Please enter title' },
            { validator: validateWhiteSpace },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name='url'
          label='URL'
          rules={[
            { required: true, message: 'Please enter URL' },
            {
              validator: validateUrl,
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditAddFiles;
